import { Link, useTranslation } from "gatsby-plugin-react-i18next";
import React from "react";

const Footer = () => {
    const {t} = useTranslation();
    
    return (
        <>
        <footer className="w-100 py-4 flex-shrink-0" data-bs-theme='dark'>
        <div className="container py-4">
            <div className="row justify-content-center">
                <div className="col-lg-4 col-md-6" >
                    <h5 className="h1 text-white">Gambit Lab</h5>
                    <p className="h5" style={{"color": "#08a1de"}} dangerouslySetInnerHTML={{__html: t("footer-title")}}></p>
                    <p className="small color-gray mb-0">{t("footer-location")}</p>
                    <p className="small color-gray mb-0">&copy; Copyrights. All rights reserved. <a className="text-white" href="#">www.gambit-lab.com</a></p>
                </div>
                <div className="col-lg-3 col-md-6">
                    <h5 className="text-white mb-3">{t("footer-company")}</h5>
                    <ul className="list-unstyled color-gray">
                        <li><Link to="/" dangerouslySetInnerHTML={{__html: t("footer-home")}}></Link></li>
                        <li><Link to="/web-development" dangerouslySetInnerHTML={{__html: t("footer-webapps")}}></Link></li>
                        <li><Link to="/app-development" dangerouslySetInnerHTML={{__html: t("footer-mobileapps")}}></Link></li>
                        <li><Link to="/xr" dangerouslySetInnerHTML={{__html: t("footer-vr")}}></Link></li>
                    </ul>
                </div>
                <div className="col-lg-2 col-md-6">
                    <h5 className="text-white mb-3">{t("footer-languages")}</h5>
                    <ul className="list-unstyled color-gray">
                        <li><a href="/en">{t("footer-english")}</a></li>
                        <li><a href="/">{t("footer-spanish")}</a></li>
                        <li><a href="/it">{t("footer-italian")}</a></li>
                    </ul>
                </div>
                <div className="col-lg-3 col-md-6">
                    <h5 className="text-white mb-3" dangerouslySetInnerHTML={{__html: t("footer-newsletter-title")}}></h5>
                    <p className="small color-gray" dangerouslySetInnerHTML={{__html: t("footer-newsletter-subtitle")}}></p>
                    <form action="#">
                        <div className="input-group mb-3">
                            <input className="form-control" type="text" placeholder="Email" aria-label="Correo electrónico" aria-describedby="button-addon2" />
                            <button className="btn btn-secondary" id="button-addon2" type="button"><i className="bi bi-send-fill"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        </footer>
        </>
    );
};

export default Footer;